export var Status;
(function (Status) {
    /**
     * Never displayed to the customer.
     */
    Status["NEW"] = "NEW";
    /**
     * Displayed, but no action taken by the customer.
     */
    Status["DISPLAYED"] = "DISPLAYED";
    /**
     * Customer interacted with the notification (click on a link, etc).
     */
    Status["READ"] = "READ";
    /**
     * Customer dismissed the notification with the "x" button.
     */
    Status["DISMISSED"] = "DISMISSED";
    /**
     * The notification was deleted by the content producer.
     */
    Status["DELETED"] = "DELETED";
})(Status || (Status = {}));
export function toStatus(value) {
    return Object.values(Status).includes(value) ? value : undefined;
}
